const DEFAULT_CURRENCY = 'NZD'

export const state = () => ({
  base: DEFAULT_CURRENCY,
  current: DEFAULT_CURRENCY,
  rates: {},
});

export const actions = {
  async load({ commit, state }, d) {
    commit('set', localStorage.getItem('currency') || window.Shopify.currency.active || DEFAULT_CURRENCY);
    commit('setBase', localStorage.getItem('baseCurrency') || window.Shopify.currency.active || DEFAULT_CURRENCY);
  },
}


export const mutations = {
  set(state, d) {
    localStorage.setItem('currency', d)
    state.current = d;
  },
  setBase(state, d) {
    localStorage.setItem('baseCurrency', d)
    state.base = d;
  },
  setRates(state, d) {
    state.rates = d.rates;
  }

}

export const getters = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
